module.exports = __webpack_public_path__ + "img/Etihad-Airways.e5a66e70.jpg";